import { Space } from "antd";
import { ReactNode } from "react";
import "./buttonCustom.css";

interface ButtonMethodCustomProps {
  text: string;
  icon?: ReactNode;
  width?: string | number;
  height?: number;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
  size?: "xsmall" | "small" | "medium" | "large" | "xlarge";
}

export const ButtonMethodCustom: React.FC<ButtonMethodCustomProps> = ({
  text,
  icon,
  width = "100%",
  height = 42,
  isSelected = false,
  onClick,
  className = "",
  size = "medium",
}) => {
  return (
    <button
      className={`button-method ${isSelected ? "selected" : ""} ${className}`}
      style={{
        width,
        height,
      }}
      onClick={onClick}
    >
      <div className="button-content">
        <Space align="center" size={8}>
          {icon && <span className="button-icon">{icon}</span>}
          <span
            className="button-text"
            style={{
              fontSize:
                size === "xsmall"
                  ? 10
                  : size === "small"
                  ? 12
                  : size === "large"
                  ? 16
                  : size === "xlarge"
                  ? 18
                  : 14,
            }}
          >
            {text}
          </span>
        </Space>
      </div>
      {isSelected && <div className="button-indicator" />}
    </button>
  );
};
